export default "__VITE_ASSET__CJpaFh$P__"